export function checkMultipleEmailsErrorFilter(EmailService) {
  'ngInject';
  return function filter (emails) {
    let [status, error] = EmailService.checkMultipleEmails(emails);
    if (!status) {
      return "'" + error + "'" + ' is not a valid email address.';
    }
  }
}
